import {NgModule} from '@angular/core';
import {GraphicsModule} from './graphics/graphics.module';
import {FileDropModule} from './directive/file-drop/file-drop.module';
import {DragAndDropModule} from './directive/drag-and-drop/drag-and-drop.module';
import {UiTranslateModule} from './directive/ui-translate/ui-translate.module';
import {FileReaderService} from './services';
import {ReplaceTagModule} from './directive/replace-tag/replace-tag.module';
import {PlatformModule} from '@angular/cdk/platform';


import jss from 'jss';
import preset from 'jss-preset-default';
import {MatNativeDateModule} from '@angular/material/core';

jss.setup(preset());

@NgModule({
    imports: [MatNativeDateModule,
        PlatformModule],
    exports: [GraphicsModule,
        FileDropModule,
        DragAndDropModule,
        UiTranslateModule,
        ReplaceTagModule,
        PlatformModule],
    providers: [FileReaderService],
    declarations: []
})
export class NpSdkGraphicsModule {
}
